import { DOCUMENT_TYPES, getPhotoLabelByKey } from '../case-dentist/scanUploadConfig';

const SCAN_LABELS = {
  upper: 'Arcade supérieure (maxillaire)',
  lower: 'Arcade inférieure (mandibulaire)',
};

function basename(pathOrName) {
  if (!pathOrName) return '';
  const parts = String(pathOrName).split('/');
  return parts[parts.length - 1] || '';
}

function inferScanTypeFromPath(filePath, fileName) {
  const hay = `${filePath || ''} ${fileName || ''}`.toLowerCase();
  if (hay.includes('-upper.stl') || hay.includes('_upper.stl')) return 'upper';
  if (hay.includes('-lower.stl') || hay.includes('_lower.stl')) return 'lower';
  return null;
}

function humanizeCamelCase(key) {
  if (!key) return '';
  return String(key)
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}

/**
 * @param {{ scan_type?: string, file_path?: string, file_name?: string, original_file_name?: string | null }} row
 */
export function resolveScanDisplayName(row) {
  const scanType =
    (row.scan_type || '').toLowerCase() ||
    inferScanTypeFromPath(row.file_path, row.file_name) ||
    '';

  if (scanType && SCAN_LABELS[scanType]) {
    return SCAN_LABELS[scanType];
  }

  const original = row.original_file_name?.trim();
  if (original) return original;

  return basename(row.file_name) || basename(row.file_path) || 'Scan STL';
}

/**
 * @param {{ photo_type?: string, file_name?: string, file_path?: string }} row
 */
export function resolvePhotoDisplayName(row) {
  const fromConfig = getPhotoLabelByKey(row.photo_type);
  if (fromConfig) return fromConfig;

  const photoType = row.photo_type?.trim();
  if (photoType) {
    const humanized = humanizeCamelCase(photoType);
    if (humanized) return humanized;
  }

  return basename(row.file_name) || basename(row.file_path) || 'Photo';
}

/**
 * @param {{ document_type?: string, file_name?: string, file_path?: string }} row
 */
export function resolveDocumentDisplayName(row) {
  const docType = row.document_type;
  if (docType) {
    const match = DOCUMENT_TYPES.find((d) => d.value === docType);
    if (match?.label) return match.label;
  }

  return basename(row.file_name) || basename(row.file_path) || 'Document';
}

export function resolveCaseFileTechnicalName(fileName, filePath) {
  return fileName || basename(filePath) || '';
}

/**
 * Détecte un fichier STL dans la liste unifiée getAllCaseFilesList (nom affiché ≠ .stl).
 * @param {{ category?: string, type?: string, fileType?: string, scanType?: string, filePath?: string, name?: string, technicalName?: string, originalName?: string }} file
 */
export function isCaseStlFile(file) {
  if (!file?.filePath) return false;

  if (file.category === 'scans' || file.type === 'scan') return true;
  if (file.fileType === 'stl') return true;
  if (file.scanType === 'upper' || file.scanType === 'lower') return true;

  const hay = [file.name, file.technicalName, file.originalName, file.filePath, basename(file.filePath)]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return hay.includes('.stl');
}

/** Format attendu par StlViewerModal / proxyStlFile. */
export function toStlViewerFileEntry(file) {
  return {
    filePath: file.filePath,
    name: file.technicalName || file.originalName || file.name || basename(file.filePath) || 'model.stl',
    size: file.size,
    fileType: 'stl',
  };
}
